// 英文消息到中文的翻译映射
const translations = {
  // 激活码相关
  'Failed to generate unique code, please try again': '生成唯一激活码失败，请重试',
  'Activation code must be exactly 6 digits': '激活码必须是6位数字',
  'This activation code already exists': '该激活码已存在',
  'Activation code created successfully': '激活码创建成功',
  'Maximum 100 codes can be generated at once': '一次最多生成100个激活码',
  'Activation code not found': '激活码不存在',
  'Activation code updated successfully': '激活码更新成功',
  'Activation code deleted successfully': '激活码删除成功',
  
  // 用户相关
  'Email already registered': '该邮箱已注册',
  'Username already taken': '用户名已被使用',
  'Registration successful': '注册成功',
  'Invalid account or password': '账号或密码错误',
  'Account is deactivated': '账户已被禁用',
  'Login successful': '登录成功',
  'Logged out successfully': '已退出登录',
  'Invitation code must be 6 digits': '邀请码必须是6位数字',
  'Invalid invitation code': '无效的邀请码',
  'Invitation code is disabled': '邀请码已被禁用',
  'Invitation code has expired': '邀请码已过期',
  'Invitation code has reached max usage': '邀请码已达到最大使用次数',
  'User created successfully': '用户创建成功',
  'User not found': '用户不存在',
  'User activated successfully': '用户已启用',
  'User deactivated successfully': '用户已禁用',
  'User deleted successfully': '用户删除成功',
  
  // 视频相关
  'Video not found': '视频不存在',
  'VIP access required': '需要VIP权限',
  'Video deleted successfully': '视频删除成功',
  
  // 设置相关
  'Setting created': '设置已创建',
  'Setting updated': '设置已更新',
  'Settings updated successfully': '设置更新成功',
  'API Key is required': 'API Key 不能为空',
  'DeepSeek API Key saved successfully': 'DeepSeek API Key 保存成功',
  'DeepSeek API Key not configured': 'DeepSeek API Key 未配置',
  'DeepSeek API connection successful': 'DeepSeek API 连接成功',
  
  // 交易员相关
  'Trader not found': '交易员不存在',
  'Name is required': '名称不能为空',
  'Trader deleted successfully': '交易员删除成功',
  
  // 交易记录相关
  'Please select an image to upload': '请选择要上传的图片',
  'Stock data not found': '未找到股票数据',
  'Please provide an array of stock symbols': '请提供股票代码数组',
  'Trade not found': '交易记录不存在',
  'Trade deleted successfully': '交易记录删除成功',
  
  // 个人资料相关
  'Profile configuration updated': '个人资料配置已更新',
  
  // 文档相关
  'Document not found': '文档不存在',
  'Document deleted successfully': '文档删除成功',
  
  // 策略相关
  'Strategy not found': '策略不存在',
  'Strategy deleted successfully': '策略删除成功',
  
  // VIP相关
  'Activation code is required': '请输入激活码',
  'Invalid activation code': '无效的激活码',
  'This activation code has been disabled': '该激活码已被禁用',
  'This activation code has expired': '该激活码已过期',
  'This activation code has reached its maximum usage limit': '该激活码已达到最大使用次数',
  'You are already a VIP member': '您已经是VIP会员',
  'Congratulations! Your VIP membership has been activated successfully!': '恭喜！您的VIP会员已成功激活！',
  
  // 弹窗相关
  'Popup configuration updated': '弹窗配置已更新',
  
  // 点赞相关
  'You have already liked today. Come back tomorrow!': '您今天已经点过赞了，明天再来吧！',
  'Like added successfully!': '点赞成功！',
  
  // AI相关
  'Stock symbol is required': '请输入股票代码',
  'AI service not configured': 'AI服务未配置',
  
  // 广播相关
  'Broadcast sent successfully': '广播发送成功',
};

// 翻译函数
export const translateMessage = (message) => {
  if (!message) return message;
  
  // 先尝试完全匹配
  if (translations[message]) {
    return translations[message];
  }
  
  // 处理带数字的动态消息
  const dynamicPatterns = [
    {
      pattern: /Successfully created (\d+) activation codes/,
      replace: (match, count) => `成功创建 ${count} 个激活码`
    },
    {
      pattern: /User (activated|deactivated) successfully/,
      replace: (match, action) => `用户已${action === 'activated' ? '启用' : '禁用'}`
    },
    {
      pattern: /Connection failed: (.+)/,
      replace: (match, error) => `连接失败: ${error}`
    }
  ];
  
  for (const { pattern, replace } of dynamicPatterns) {
    const match = message.match(pattern);
    if (match) {
      return replace(...match);
    }
  }
  
  return message;
};

export default translateMessage;

